<a [ngStyle]="{'color': isGGStaticPage ? ggStaticColors.secondary : ''}"
	class="quickview-cta"
	[attr.altText]="ctaText"
	[attr.aria-label]="ctaText"
	(click)="useProductQuickView(ecode)">
	{{ctaText}}
	<i *ngIf="ctaIcon() !== ''" class="quickview-cta__icon material-icons">{{ ctaIcon() }}</i>
</a>